import React from 'react';
import { Card } from './ui/card';

const BenefitsSection = () => {
  const benefits = [
    {
      title: 'Save Real Money',
      description: '20-50% reduction in monthly expenses. Not through sacrifice — through better systems and smarter defaults.'
    },
    {
      title: 'Gain Freedom',
      description: "Less financial pressure means more choices. Work because you want to, not because you have to."
    },
    {
      title: 'Build Self-Reliance',
      description: 'Grow food, generate energy, fix things yourself. Skills that make you resilient no matter what happens.'
    }
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-[#2C1810] mb-4 text-center">
          What Changes When You Spend Less
        </h2>
        <p className="text-[#5A5046] text-lg text-center mb-16">
          This isn't about giving things up. It's about gaining what matters.
        </p>
        
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <Card key={index} className="bg-[#EBE6D8] border-none p-8 hover:shadow-lg transition-shadow">
              <div className="mb-4">
                <div className="w-12 h-12 rounded-full bg-[#6B7A5C] text-white flex items-center justify-center font-bold text-xl">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-2xl font-bold text-[#2C1810] mb-3">
                {benefit.title}
              </h3>
              <p className="text-[#5A5046] leading-relaxed">
                {benefit.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;